module.exports = __webpack_public_path__ + "img/邮件警告.96db2f6f.jpg";